export function GoogleButton({ onClick, disabled }: { onClick: () => void; disabled?: boolean }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="flex h-12 w-full items-center justify-center gap-2.5 rounded-xl border border-cream-200 bg-white text-sm font-semibold text-ink-900 transition-colors hover:bg-cream-100 disabled:opacity-60 dark:border-night-border dark:bg-night-surface-raised dark:text-night-text dark:hover:bg-night-surface"
    >
      <svg viewBox="0 0 24 24" className="h-4.5 w-4.5">
        <path fill="#4285F4" d="M23.52 12.27c0-.85-.08-1.67-.22-2.45H12v4.64h6.46a5.52 5.52 0 0 1-2.4 3.62v3h3.87c2.27-2.09 3.58-5.17 3.58-8.81Z" />
        <path fill="#34A853" d="M12 24c3.24 0 5.95-1.07 7.93-2.92l-3.87-3c-1.08.72-2.45 1.15-4.06 1.15-3.12 0-5.77-2.11-6.71-4.94H1.3v3.09A12 12 0 0 0 12 24Z" />
        <path fill="#FBBC05" d="M5.29 14.29A7.2 7.2 0 0 1 4.91 12c0-.8.14-1.57.38-2.29V6.62H1.3A12 12 0 0 0 0 12c0 1.94.46 3.77 1.3 5.38l3.99-3.09Z" />
        <path fill="#EA4335" d="M12 4.77c1.76 0 3.34.61 4.59 1.8l3.44-3.44C17.94 1.19 15.23 0 12 0A12 12 0 0 0 1.3 6.62l3.99 3.09C6.23 6.88 8.88 4.77 12 4.77Z" />
      </svg>
      Mit Google fortfahren
    </button>
  );
}
